import { useEffect, useState } from "react";
import { Check, X } from "lucide-react";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("xe_cookie_consent")) {
      const t = setTimeout(() => setVisible(true), 1800);
      return () => clearTimeout(t);
    }
  }, []);
  const choose = (v) => {
    localStorage.setItem("xe_cookie_consent", v);
    setVisible(false);
  };
  if (!visible) return null;
  return (
    <div
      className="glass fixed bottom-20 left-4 right-4 z-40 rounded-xl border border-black/10 p-5 shadow-2xl sm:bottom-6 sm:left-6 sm:right-auto sm:max-w-sm"
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-consent"
    >
      <p className="text-sm leading-relaxed text-muted">
        We use cookies and similar technologies to improve your experience and analyze site traffic. See our{" "}
        <a href="/privacy-policy" className="text-aqua underline underline-offset-2">Privacy Policy</a>.
      </p>
      <div className="mt-4 flex gap-3">
        <button onClick={() => choose("accepted")} className="btn-primary flex-1 !px-4 !py-2 !text-xs" data-testid="cookie-accept-btn">
          <Check size={14} /> Accept
        </button>
        <button onClick={() => choose("declined")} className="btn-ghost flex-1 !px-4 !py-2 !text-xs" data-testid="cookie-decline-btn">
          <X size={14} /> Decline
        </button>
      </div>
    </div>
  );
};
